"use client";

export function ScrollToButton({
  targetId,
  children,
  className,
}: {
  targetId: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <button
      onClick={() =>
        document
          .getElementById(targetId)
          ?.scrollIntoView({ behavior: "smooth" })
      }
      className={
        className ??
        "bg-transparent text-warm-bg/90 px-8 py-3.5 rounded-sm text-[15px] font-semibold border-[2px] border-warm-bg/30 cursor-pointer font-sans transition-all hover:bg-warm-bg/10 min-h-[44px]"
      }
    >
      {children}
    </button>
  );
}
